type Nullable<T> = T | null;

class TabController {
    tab: Nullable<Element> = null;
    activeTabNumber: string = '1';
    targetClassList: Nullable<DOMTokenList> = null

    constructor() {
        this.tab = document.querySelector<Element>('.skyes-legacy__tab-container');

        if (this.tab) {
            this.tab.addEventListener('click', (event: Event) => {
                this.clickHandler(event)
            });
        }
    }

    removeActiveClass() {
        if (this.tab && (this.targetClassList && this.targetClassList.contains('tab-title'))) {
            this.tab.querySelectorAll('.active').forEach(elm => {
                elm.classList.remove('active');
            })
        }
    }

    clickHandler(event: Event) {
        const target = event.target;
        if (target && target instanceof HTMLElement) {
            this.targetClassList = target.classList;
            this.removeActiveClass();
            if (target.dataset.tab) {
                this.activeTabNumber = target.dataset.tab;
                if(this.tab) {
                    const toBeActiveTab = this.tab.querySelector(`[data-tab="${this.activeTabNumber}"]`);
                    const toBeActiveCon = this.tab.querySelector(`[data-tab-num="${this.activeTabNumber}"]`);

                    if (toBeActiveTab && toBeActiveCon) {
                        toBeActiveTab.classList.add('active');
                        toBeActiveCon.classList.add('active');
                    }
                }
            }
        }
    }
}

const swiperOpt = {
    allowTouchMove: false,
    speed: 500,
    autoplay: {
        delay: 3000
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
    },
    loop: true
}


document.addEventListener('DOMContentLoaded', () => {
    if(location.pathname.includes('youth-voice')) {
        const slides = document.querySelectorAll('.swiper-slide')
        if(slides.length > 1) {
            // @ts-ignore
            const swiper = new Swiper('.swiper', swiperOpt)
        }
    } else {
        new TabController();
    }
})
